import React, {Component} from "react";

import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import {Button, ButtonGroup, Col, Container, DropdownItem, Label, Row} from "reactstrap";
import {connect} from "react-redux";
import {commons, DetailValue, DocIndexField, FixedDropDownButton, Icon, MCIcon, modal, PdfViewer} from "@mc/mc-legacy";
import PodepsatDokumentForm from "./forms/PodepsatDokumentForm";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import QSignDocumentApproveApi from "../api/gen/qsign/QSignDocumentApproveApi";
import OdmitnutiForm from "./forms/OdmitnutiForm";
import * as appUtils from "../utils/appUtils";
import classNames from "classnames";
import {isArray} from "lodash-es";
import * as mojeUkolyActions from "../actions/mojeUkolyActions";
import * as groupMenuActions from "../actions/groupMenuActions";
import SchvaleniForm from "./forms/SchvaleniForm";
import {PrubehPodepisovaniModal} from "./forms/PrubehPodepisovaniModal";
import {Modal, Popover, Position} from "@mc/react-core";
import {toastr} from "../utils/mc-toastr";
import "./PodepisovaniPdfViewer.scss";
import QSignDataApi from "../api/gen/qsign/QSignDataApi";
import SeznamPriloh from "./SeznamPriloh";
import {H2} from "@mc/ui-v3";
import {withRouter} from "react-router";
import Linkify from "../utils/parseUrl";
import moment from "moment/moment";

const {sinkEvent} = commons;

/**
 * PDF čtečka záklaní implementace
 */

class PodepisovaniPdfViewer extends Component<Props> {
    static VIEW_MODE = {
        BASE: "BASE",
        MOBILE: "MOBILE",
    };

    constructor(props) {
        super(props);
        this.state = {
            mobileInfoVisible: false,
            mobilePanelsVisible: true,
            startLine: 0,
            moveLine: 0,
            mouseClick: null,
            xScale: 0,
            yScale: 0,
            rotation: 0,
            stampMode: false,
            innerHeight,
            generateSummary: false,
            showedPodpis: false,
            divWidth: props.stampSize.width,
        };
        this.resizeObserver = null; // Instance ResizeObserver
    }

    componentDidMount(): void {
        document.addEventListener("mousedown", this.handleClickOutSide);
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any) {
        const divElement = document.getElementById("signDiv");
        if (divElement && this.resizeObserver == null) {
            this.resizeObserver = new ResizeObserver(this.updateDivSize).observe(divElement);
        }
    }

    componentWillUnmount(): void {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect(); // Odpojení ResizeObserveru
        }
        document.removeEventListener("mousedown", this.handleClickOutSide);
    }

    updateDivSize = () => {
        const el = document.getElementById("signDiv");
        if (el) {
            if (el.style.width && this.state.divWidth != el.style.width) {
                this.setState({
                    divWidth: el.style.width,
                })
            }
        }
    }

    setHeaderInfoRef = (node) => {
        this.headerRef = node;
    };
    // vlastni funkce pro rozsireni ctecky - renderMetaItem a renderActions
    handleClickOutSide = (event) => {
        const {mobileInfoVisible} = this.state;

        if (this.headerRef && !this.headerRef.contains(event.target) && mobileInfoVisible === true) {
            this.setState({
                mobileInfoVisible: false,
            });
        }
    };
    renderRejectItem = (rejectItem) => {
        const signer = rejectItem.signer;
        return (
            <div className="meta-body reject">
        <span className="meta-text">
          Dokument odmítnut uživatelem <span className="signer">{appUtils.getPracovnikLabel(signer)}</span>{" "}
            <span className="date">({commons.dateToDateTimeString(rejectItem.date)})</span>
        </span>
                {rejectItem.reason && <span className="note">{rejectItem.reason}</span>}
            </div>
        );
    };

    renderErrorItem = (errorItem) => {
        return (
            <div className="meta-body error">
                <span className="date">{commons.dateToDateTimeString(errorItem.date)}: </span>
                <span className="meta-text">{errorItem.message}</span>
            </div>
        );
    };
    renderUserSignItem = (userSignItem) => {
        const signer = userSignItem.signer;
        return (
            <div className="meta-body user-sign">
        <span className="meta-text">
          Dokument podepsán uživatelem <span className="signer">{appUtils.getPracovnikLabel(signer)}</span>{" "}
            <span className="date">({commons.dateToDateTimeString(userSignItem.date)})</span>
        </span>
                {userSignItem.note && <span className="note">{userSignItem.note}</span>}
            </div>
        );
    };
    renderMessageItem = (messageItem) => {
        return (
            <div className="meta-body message">
                <span className="meta-text">{messageItem.message}</span>
            </div>
        );
    };
    renderSealSignItem = (sealSignItem) => {
        return (
            <div className="meta-body seal-sign">
        <span className="meta-text">
          Dokument opatřen systémovou pečetí{sealSignItem.timeStamp && ", včetně časového razítka"}{" "}
            <span className="date">({commons.dateToDateTimeString(sealSignItem.date)}</span>)
        </span>
            </div>
        );
    };
    renderApprovedItem = (approvedItem) => {
        const approver = approvedItem.signer;
        return (
            <div className="meta-body user-sign">
        <span className="meta-text">
          Dokument schválen uživatelem <span className="signer">{appUtils.getPracovnikLabel(approver)}</span>{" "}
            <span className="date">({commons.dateToDateTimeString(approvedItem.date)})</span>
        </span>
                {approvedItem.note && <span className="note">{approvedItem.note}</span>}
            </div>
        );
    };
    renderWaitingApproverItem = (item) => {
        const approver = item.approver;
        return (
            <div className="meta-body user-sign">
        <span className="meta-text">
          Čeká se na schválení uživatelem <span
            className="signer">{appUtils.getPracovnikLabel(approver)}</span> ({item.stepName})
        </span>
            </div>
        );
    };
    renderNonApprovedItem = (nonApprovedItem) => {
        const approver = nonApprovedItem.signer;
        return (
            <div className="meta-body user-sign">
        <span className="meta-text">
          Dokument neschválen uživatelem <span className="signer">{appUtils.getPracovnikLabel(approver)}</span>{" "}
            <span className="date">({commons.dateToDateTimeString(nonApprovedItem.date)})</span>
        </span>
                {nonApprovedItem.note && <span className="note">{nonApprovedItem.note}</span>}
            </div>
        );
    };
    renderMetaItem = (item) => {
        let body;
        let icon;
        let mcicon;
        let cls = ["meta-icon"];

        switch (item["@class"]) {
            //TODO dodělat ikony/barvy/classy
            case "RejectItem":
                body = this.renderRejectItem(item);
                icon = "times";
                cls.push("reject");
                break;

            case "ErrorItem":
                body = this.renderErrorItem(item);
                mcicon = "attention";
                cls.push("error");
                break;

            case "UserSignItem":
                body = this.renderUserSignItem(item);
                icon = "check";
                cls.push("user-sign");
                break;

            case "MessageItem":
                body = this.renderMessageItem(item);
                icon = "info-circle";
                cls.push("message");
                break;

            case "SealSignItem":
                body = this.renderSealSignItem(item);
                mcicon = "title";
                cls.push("seal-sign");
                break;

            case "ApprovedItem": {
                body = this.renderApprovedItem(item);
                icon = "thumbs-o-up";
                cls.push("user-approve");
                break;
            }

            case "WaitingApproverItem": {
                body = this.renderWaitingApproverItem(item);
                icon = "exclamation-triangle";
                cls.push("user-waiting-approver");
                break;
            }

            case "NonApprovedItem": {
                body = this.renderNonApprovedItem(item);
                icon = "times";
                cls.push("reject");
                break;
            }
        }

        return (
            <div className="meta-item">
                {icon && (
                    <div className={classNames(cls)}>
                        <Icon icon={icon}/>
                    </div>
                )}
                {mcicon && (
                    <div className={classNames(cls)}>
                        <MCIcon icon={mcicon}/>
                    </div>
                )}
                {body}
            </div>
        );
    };
    createReturnUrl = (requestId?: number) => {
        const {viewMode} = this.props;
        let mode = "base";

        if (viewMode === PodepisovaniPdfViewer.VIEW_MODE.MOBILE) {
            mode = "mobile";
        }

        const searchParams = new URLSearchParams();
        searchParams.append("mode", mode);

        if (requestId != null) {
            // tady je schvalne jedno rovnitko!
            searchParams.append("showId", requestId);
        }

        return window.location.origin + moduleContextPath + "/close-page";
    };

    handlePodepsat = (inner) => {
        const {actions, state} = inner;
        const {view, documentMeta} = state;
        const signatureStamp = this.getStampMetadata(inner);

        this.props.dispatch(
            modal.ModalActions.show(
                PodepsatDokumentForm,
                {
                    onSubmit: (data) => {
                        this.props.dispatch(modal.ModalActions.hide());
                        this.zahajitPodepisovani(data, actions, view, documentMeta, signatureStamp, false);
                    },
                    viewId: view.id,
                },
                "Podepsat dokument"
            )
        );
    };

    zahajitPodepisovani = (data, actions, view, documentMeta, signatureStamp, vse) => {
        const returnUrl = this.createReturnUrl();
        Modal.show((props) => (
            <PrubehPodepisovaniModal
                {...props}
                cert={data.certificate}
                viewId={view.id}
                returnUrl={returnUrl}
                signatureStamp={signatureStamp}
                vse={vse}
                documentId={documentMeta ? documentMeta.id : null}
                onFail={() => {
                    this.props.dispatch(mojeUkolyActions.invalidateMuNevyrizene());
                    this.props.dispatch(groupMenuActions.invalidate());
                    if (this.state.stampMode) {
                        this.setState({
                            mouseClick: null,
                            xScale: null,
                            yScale: null,
                            stampMode: false
                        })
                    }

                    SignRequestInternalApi.nextInitDocument(view.id).then((data) => {
                        if (data.documentView != null) {
                            actions.select(data.documentView);
                        }
                    });
                }}
                onSuccess={() => {
                    this.props.dispatch(mojeUkolyActions.invalidateMuNevyrizene());
                    this.props.dispatch(groupMenuActions.invalidate());
                    this.setState({
                        xScale: null,
                        yScale: null,
                    })
                    if (this.state.stampMode) {
                        this.setState({
                            mouseClick: null,
                            stampMode: false
                        })
                    }

                    if (!actions.next()) {
                        SignRequestInternalApi.nextInitDocument(view.id).then((data) => {
                            if (data.documentView != null) {
                                if (!actions.select(data.documentView)) {

                                    actions.close();
                                    // pokud nebyl vybrán zavřeme okno také
                                }
                            } else {
                                this.props.history.push("/ukoly/historie");
                                actions.close();
                                Modal.hide();
                            }
                        });
                    } else if (vse) {
                        this.props.history.push("/ukoly/historie");
                        actions.close();
                        Modal.hide();
                    }
                }}
            />
        ));
    };

    //TODO napojit na api pro podpis
    handlePodepsatVse = (inner) => {
        const {actions, state} = inner;
        const {view} = state;
        const signatureStamp = this.getStampMetadata(inner);
        this.props.dispatch(
            modal.ModalActions.show(
                PodepsatDokumentForm,
                {
                    onSubmit: (data) => {
                        this.props.dispatch(modal.ModalActions.hide());
                        this.zahajitPodepisovani(data, actions, view, null, signatureStamp, true);
                    },
                    viewId: view.id,
                },
                "Podepsat všechny dokumenty"
            )
        );
    };
    handleOdmitnout = (inner) => {
        const {actions, state} = inner;
        const {view, documentMeta} = state;
        this.props.dispatch(
            modal.ModalActions.show(
                OdmitnutiForm,
                {
                    viewId: view.id,
                    showClose: true,
                    onSubmit: (data) => {
                        return SignRequestInternalApi.declineSignDocument(view.id, documentMeta.id, {
                            reason: data.reason,
                        });
                    },
                    onSubmitSuccess: (result, dispatch) => {
                        dispatch(modal.ModalActions.hide());

                        if (!actions.next()) {
                            SignRequestInternalApi.nextInitDocument(view.id).then((data) => {
                                if (data.documentView != null) {
                                    if (!actions.select(data.documentView)) {
                                        actions.close(); // pokud nebyl vybrán zavřeme okno také
                                    }
                                } else {
                                    actions.close();
                                }
                            });
                        }
                    },
                    closeIcon: "times",
                },
                "Odmítnutí dokumentu"
            )
        );
    };
    handleOdmitnoutVse = (inner) => {
        const {actions, state} = inner;
        const {view, documentMeta} = state;
        this.props.dispatch(
            modal.ModalActions.show(
                OdmitnutiForm,
                {
                    viewId: view.id,
                    showClose: true,
                    onSubmit: (data) => {
                        return SignRequestInternalApi.declineAllSignDocument(view.id, documentMeta.id, {
                            reason: data.reason,
                        });
                    },
                    onSubmitSuccess: (result, dispatch) => {
                        dispatch(modal.ModalActions.hide());
                        actions.close();
                    },
                    closeIcon: "times",
                },
                "Odmítnout vše"
            )
        );
    };
    //
    handleSchvalit = (inner) => {
        const {actions, state} = inner;
        const {view, documentMeta} = state;
        this.props.dispatch(
            modal.ModalActions.show(
                SchvaleniForm,
                {
                    viewId: view.id,
                    showClose: true,
                    onSubmit: (data) => {

                        return QSignDocumentApproveApi.acceptDocument(view.id, documentMeta.id, {text: data.reason});
                    },
                    onSubmitSuccess: (result, dispatch) => {
                        dispatch(modal.ModalActions.hide());

                        if (!actions.next()) {
                            if (view.documents.length === 1 && documentMeta.meta.approver && documentMeta.meta.signer) {
                                actions.refresh();
                            } else {
                                SignRequestInternalApi.nextInitDocument(view.id).then((data) => {
                                    if (data.documentView != null) {
                                        if (!actions.select(data.documentView)) {
                                            actions.close(); // pokud nebyl vybrán zavřeme okno také
                                        }
                                    } else {
                                        actions.close();
                                    }
                                });
                            }
                        }
                    },
                    closeIcon: "times",
                },
                "Schválení dokumentu"
            )
        );
    };
    handleSchvalitVse = (inner) => {
        const {actions, state} = inner;
        const {view, documentMeta} = state;
        const multipleDocuments = isArray(view.documents) && view.documents.length > 1;
        this.props.dispatch(
            modal.ModalActions.show(
                SchvaleniForm,
                {
                    viewId: view.id,
                    showClose: true,
                    onSubmit: (data) => {
                        return QSignDocumentApproveApi.acceptAllDocuments(view.id, documentMeta.id, {text: data.reason});
                    },
                    onSubmitSuccess: (result, dispatch) => {
                        dispatch(modal.ModalActions.hide());
                        actions.close();
                    },
                    closeIcon: "times",
                },
                "Schválit vše"
            )
        );
    };
    handleNeschvalit = (inner) => {
        const {actions, state} = inner;
        const {view, documentMeta} = state;
        this.props.dispatch(
            modal.ModalActions.show(
                OdmitnutiForm,
                {
                    viewId: view.id,
                    showClose: true,
                    onSubmit: (data) => {
                        return QSignDocumentApproveApi.rejectDocument(view.id, documentMeta.id, {text: data.reason});
                    },
                    onSubmitSuccess: (result, dispatch) => {
                        dispatch(modal.ModalActions.hide());

                        if (!actions.next()) {
                            SignRequestInternalApi.nextInitDocument(view.id).then((data) => {
                                if (data.documentView != null) {
                                    if (!actions.select(data.documentView)) {
                                        actions.close(); // pokud nebyl vybrán zavřeme okno také
                                    }
                                } else {
                                    actions.close();
                                }
                            });
                        }
                    },
                    closeIcon: "times",
                },
                "Odmítnutí dokumentu"
            )
        );
    };
    handleNeschvalitVse = (inner) => {
        const {actions, state} = inner;
        const {view, documentMeta} = state;
        this.props.dispatch(
            modal.ModalActions.show(
                OdmitnutiForm,
                {
                    viewId: view.id,
                    showClose: true,
                    onSubmit: (data) => {
                        return QSignDocumentApproveApi.rejectAllDocuments(view.id, documentMeta.id, {text: data.reason});
                    },
                    onSubmitSuccess: (result, dispatch) => {
                        dispatch(modal.ModalActions.hide());
                        actions.close();
                    },
                    closeIcon: "times",
                },
                "Odmítnout vše"
            )
        );
    };
    handlePrevzitSchvalovatelem = (inner) => {
        const {actions, state} = inner;
        const {view, documentMeta} = state;
        return QSignDocumentApproveApi.prevezmi(view.id, documentMeta.id).then(() => {
            console.log('Vřevzetí ke schválení dokončeno');
            actions.refresh();
        });
    };
    handleSetPanelsVisible = () => {
        const {mobilePanelsVisible} = this.state;
        this.setState({
            mobilePanelsVisible: !mobilePanelsVisible,
        });
    };
    handleSetPanelsInvisible = () => {
        const {mobilePanelsVisible} = this.state;

        if (mobilePanelsVisible !== false) {
            this.setState({
                mobilePanelsVisible: false,
            });
        }
    };
    getStampMetadata = (inner) => {
        const mouseClick = this.state.mouseClick;
        const {width} = this.props.stampSize;
        const {divWidth} = this.state;

        const intWidth = parseInt(divWidth)
        const resizeScale = intWidth / width;

        if (!mouseClick) {
            return null;
        }

        const rotation = this.state.rotation;
        const x = Math.max(0, mouseClick.x);
        const y = Math.max(0, mouseClick.y);

        const signHeight = (intWidth / 5)

        const xRatio = x / mouseClick.width
        const yRatio = y / mouseClick.height
        const wRatio = intWidth / mouseClick.width
        const hRatio = signHeight / mouseClick.height

        // někde v zobrazení visí odsazení a je nutné ho zahrnout
        const border = 16
        const finalX = (xRatio * border) + x
        const finalY = (yRatio * border) + y
        const finalW = (wRatio * border) + intWidth
        const finalH = (hRatio * border) + signHeight

        if ((finalX + finalW) > mouseClick.width || (finalY + finalH) > mouseClick.height) {
            toastr.warning("Vizuální podpis zasahuje mimo dokument a nebude tedy vložen.");
            return null;
        }

        return {
            x: finalX,
            y: finalY,
            width: finalW,
            height: finalH,
            pageNumber: mouseClick.pageNumber,
            pageWidth: mouseClick.width,
            pageHeight: mouseClick.height,
            zoom: this.mouseClickZoom / resizeScale,
            rotation,
        };
    };
    renderActions = (inner) => {
        const {signRequest} = this.props;
        const {actions, state} = inner;
        const {documentMeta, view} = state;

        const disabledSign = !this.state.mouseClick && this.state.stampMode;

        if (documentMeta) {
            const meta = documentMeta.meta;
            const results = [];
            // testovací data
            // const items = [...meta.items, {"@class": "ErrorItem", message: "chyba", date: "2019-02-03 13:30"},
            //     {"@class": "UserSignItem", signer: {uplneJmeno: "Pepa Nováj"}, date: "2019-02-03 13:30"},
            //     {"@class": "SealSignItem", timeStamp: true, date: "2019-02-03 13:30"}];
            const items = meta.items;
            const approveeveryone = meta.approveeveryone;

            if (items) {
                results.push(
                    <div
                        className="meta-items metaScrollBar "
                        style={{
                            overflowY: "auto",
                            paddingRight: "10px",
                        }}
                    >
                        {items.map(this.renderMetaItem)}
                    </div>
                );
            }

            if (approveeveryone > 1) {
                results.push(
                    <div className={"podepisovani-pdf-actions px-2 mt-1"} key="prevzitAction">
                        <Row>
                            <Col className={"podepisovani-button"} xs={12}>
                                <Button className="btn-prevzit-schvalovatelem w-100"
                                        disabled={disabledSign || this.state.stampMode || this.state.showedPodpis}
                                        onClick={() => this.handlePrevzitSchvalovatelem(inner)}>
                                    Převzít
                                </Button>
                            </Col>
                        </Row>
                    </div>
                );
            } else {
                if (meta.signer && meta.status === "INIT") {
                    results.push(
                        <div className={"podepisovani-pdf-actions px-2 mt-1"} key="unsignedActions">
                            <Row>
                                <Col className={"podepisovani-button"} xs={12}>
                                    <Button
                                        className="btn-umisteni-podpisu w-100"
                                        disabled={disabledSign || this.state.stampMode}
                                        onClick={() =>
                                            this.setState({
                                                stampMode: !this.state.stampMode,
                                                showedPodpis: true,
                                            })
                                        }
                                    >
                                        Zvolit umístění podpisu
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col className={"podepisovani-button pr-2 mb-0"} xs={6}>
                                    <Button disabled={disabledSign || this.state.stampMode} className="btn-sign  w-100"
                                            onClick={() => this.handlePodepsat(inner)}>
                                        Podepsat
                                    </Button>
                                </Col>
                                <Col className={"podepisovani-button pl-2 mb-0"} xs={6}>
                                    <Button onClick={() => this.handlePodepsatVse(inner)}
                                            disabled={disabledSign || this.state.stampMode}
                                            className="btn-sign podepisovani-button w-100"
                                    >Podepsat vše
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    );
                }

                if (meta.approver && meta.status === "INIT" && !this.props.reedOnly) {
                    results.push(
                        <div className={"podepisovani-pdf-actions flex-shrink-0 px-2 mt-1"} key="SchvalenoActions">
                            <Row>
                                <Col xs={6} className="schvaleni-button pr-2 ">
                                    <Button disabled={disabledSign || this.state.stampMode} className="btn-sign w-100"
                                            onClick={() => this.handleSchvalit(inner)}>
                                        Schválit
                                    </Button>
                                </Col>

                                <Col xs={6} className="schvaleni-button pl-2 ">
                                    <Button onClick={() => this.handleSchvalitVse(inner)}
                                            disabled={disabledSign || this.state.stampMode}
                                            className="btn-sign w-100">
                                        Schválit vše
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    );
                }
                if ((meta.approver || meta.signer) && meta.status === "INIT" && !this.props.reedOnly) {
                    results.push(<div className={"podepisovani-pdf-actions flex-shrink-0 px-2 mt-1"}
                                      key="SchvalenoActions">
                        <Row>
                            <Col className={"podepisovani-button pr-2"} xs={6}>
                                <Button disabled={disabledSign || this.state.stampMode} className="btn-decline  w-100"
                                        onClick={() => {
                                            meta.approver ? this.handleNeschvalit(inner) : this.handleOdmitnout(inner)
                                        }}>
                                    Odmítnout
                                </Button>
                            </Col>
                            <Col className={"podepisovani-button pl-2"} xs={6}>
                                <Button onClick={() => {
                                    meta.approver ? this.handleNeschvalitVse(inner) : this.handleOdmitnoutVse(inner)
                                }} disabled={disabledSign || this.state.stampMode}
                                        className="btn-decline  w-100">
                                    Odmítnout vše
                                </Button>
                            </Col>
                        </Row>
                    </div>)
                }
            }
            return (
                <div
                    className="podepisovani-pdf-viewer d-flex flex-column"
                    style={{
                        minHeight: 0,
                    }}
                >
                    {results}
                </div>
            );
        }
    };
    formatDate = (date) => {
        return moment(date).format("D.M.YYYY");
    };
    renderMetadata = (inner) => {
        const {actions, state} = inner;
        const {signRequest} = this.props;
        if (signRequest) {
            const predkladatel = signRequest.pracovnikRequest;
            let pracovniLabel = signRequest.pracovnikSignList.map((pracovnik) => appUtils.getPracovnikLabel(pracovnik));
            pracovniLabel = pracovniLabel.join(", ");
            const predkladatelFinal = appUtils.getPracovnikLabel(predkladatel);
            return (
                <div className="meta">
                    <DetailValue className="mb-1" label={false} textOverflow valueTitle={predkladatelFinal}>
                        {"Předkladatel: "}
                        {predkladatelFinal}
                    </DetailValue>
                    <DetailValue label={false} textOverflow valueTitle={pracovniLabel}>
                        {"Podepisující: "}
                        {signRequest.pracovnikSignList.find((signer) => signer.blocked === true) ? (
                            <span className="blocked">{pracovniLabel}</span>
                        ) : (
                            pracovniLabel
                        )}
                    </DetailValue>
                    {signRequest.signUntil &&
                        <DetailValue label={false} textOverflow valueTitle={pracovniLabel}>
                            {"Termín zpracování: "}
                            {this.formatDate(signRequest.signUntil)}
                        </DetailValue>
                    }
                    {signRequest.description && <>
                        <div>Poznámka:</div>
                        <Popover
                            className={"custom-popover"}
                            minimal
                            portalClassName={"custom-popover-portal"}
                            content={
                                <div className={"p-2 max-popover-width max-popover-width-prohlizecka"}>
                                    <Linkify text={signRequest.description}/>
                                </div>
                            }
                            position={Position.BOTTOM_LEFT}
                        ><Linkify className={"truncate-text-prohlizecka"} text={signRequest.description}/></Popover></>}
                    {signRequest.attachmentCount > 0 && <div className="attachment-section mt-2">
                        Dávka obsahuje <span title={`Zobrazit přílohy (${signRequest.attachmentCount})`}
                                             onClick={() => this.handleZobrazitPrilohy(signRequest.id)}
                                             className="attachment-link">přílohy</span>
                    </div>}
                </div>
            );
        }
    };

    handleZobrazitPrilohy = (id) => {
        const {dispatch} = this.props;
        return SignRequestInternalApi.getRequestAttachments(id).then((response) => {
            dispatch(modal.ModalActions.show(SeznamPriloh, {data: response}, "Přílohy", {}));
        });
    };

    computeSignCoordinates = () => {
        const {marginLeft, marginTop} = this.state.mouseClick;
        const canvas = document.querySelector(".react-pdf__Page__canvas");
        if (canvas) {
            const computedStyle = window.getComputedStyle(canvas);
            const marginLeftC = parseInt(computedStyle.marginLeft, 10);
            const marginTopC = parseInt(computedStyle.marginTop, 10);

            const xShift = marginLeftC - marginLeft;
            const yShift = marginTopC - marginTop;

            if (this.state.mouseClick) {
                const xScale = ((canvas.offsetWidth / this.state.mouseClick.width) * this.state.mouseClick.x) + xShift;
                const yScale = ((canvas.offsetHeight / this.state.mouseClick.height) * this.state.mouseClick.y) + yShift;

                this.setState({
                    xScale: xScale,
                    yScale: yScale,
                });
            }
        }
    }

    renderZoomControl = (iconSize, inner) => {
        const {actions, state} = inner;
        const {totalPageCount, actualPage} = state;
        const zoomAmount = 0.1;
        return (
            <div className={"zoom-control"}>
                <div className={"zoom-text"}>
                    <Label className={"zoom-info"}>
                        Stránky <span className={"current-doc-num"}>{actualPage + 1}</span> z{" "}
                        {totalPageCount ? totalPageCount : "?"}
                    </Label>
                </div>

                <div className={"zoom-controls border-rigth"}>
                    <div className={"zoom-minus"}>
                        <Button className={"btn-transparent"} onClick={() => {
                            actions.zoomOut(zoomAmount)
                            requestAnimationFrame(() => {
                                this.computeSignCoordinates();
                            });
                        }}
                                title={"Oddálit"}>
                            <Icon icon={"search-minus " + iconSize}/>
                        </Button>
                    </div>
                    <div className={"zoom-plus"}>
                        <Button className={"btn-transparent"} onClick={() => {
                            actions.zoomIn(zoomAmount)
                            requestAnimationFrame(() => {
                                this.computeSignCoordinates();
                            });
                        }}
                                title={"Přiblížit"}>
                            <Icon icon={"search-plus " + iconSize}/>
                        </Button>
                    </div>
                </div>

                <div className={"zoom-controls"}>
                    <div className={"zoom-minus"}>
                        <Button
                            className={"btn-transparent"}
                            onClick={() => {
                                actions.rotateRight();
                                this.setState({
                                    rotation: (this.state.rotation + 1) % 4,
                                });
                            }}
                            title={"Otočit po směru hodin"}
                        >
                            <Icon icon={"rotate-right" + iconSize}/>
                        </Button>
                    </div>
                    <div className={"zoom-plus"}>
                        <Button
                            className={"btn-transparent"}
                            onClick={() => {
                                actions.rotateLeft();
                                this.setState({
                                    rotation: (this.state.rotation + 3) % 4,
                                });
                            }}
                            title={"Otočit proti směru hodin"}
                        >
                            <Icon icon={"rotate-left" + iconSize}/>
                        </Button>
                    </div>
                </div>
            </div>
        );
    };
    renderHeader = (iconSize, inner) => {
        const {actions, state} = inner;
        const {view, documentIndex, documentMeta} = state;
        const {mobileInfoVisible} = this.state;
        const meta = documentMeta && documentMeta.meta;
        const results = [];
        const items = meta && meta.items;
        const {signRequest} = this.props;
        const predkladatel = signRequest?.pracovnikRequest;
        let pracovniLabel = signRequest?.pracovnikSignList.map((pracovnik) => appUtils.getPracovnikLabel(pracovnik));
        if (items) {
            results.push(items.map(this.renderMetaItem));
        }

        return (
            <div ref={this.setHeaderInfoRef} className={"header-mobile"}>
                <Row className="ml-4 mr-4">
                    <Col xs={9} sm={9} className={"header-document-number p-0"}>
                        {view && this.renderDocNumLabel(inner)}
                        <span
                            className="header-info ml-4"
                            onClick={sinkEvent(() =>
                                this.setState({
                                    mobileInfoVisible: !mobileInfoVisible,
                                })
                            )}
                        >
              <Icon icon="info-circle"/>

                            {signRequest && signRequest.attachmentCount > 0 &&
                                <Icon className="prilohy-icon ml-3" icon={"file"}/>}
                            {documentMeta?.meta.approving === "UNDERWAY" &&
                                <Icon className="info-icon approvering-underway ml-3"
                                      icon={"exclamation-triangle"}/>}
            </span>


                    </Col>
                    <Col xs={3} sm={3} className={"header-close p-0"}>
                        {this.renderCloseButton(iconSize, inner)}
                    </Col>
                </Row>
                {mobileInfoVisible && (
                    <Row className={"ml-2 mr-2"}>
                        <Col className={"meta-items"}>
                            <div>Předkladatel: {appUtils.getPracovnikLabel(predkladatel)}</div>
                            {signRequest && <DetailValue textOverflow valueTitle={pracovniLabel}>
                                {"Podepisující: "}
                                {signRequest.pracovnikSignList.find((signer) => signer.blocked === true) ? (
                                    <span className="blocked">{pracovniLabel}</span>
                                ) : (
                                    pracovniLabel
                                )}
                            </DetailValue>}
                            <Popover
                                portalClassName={"custom-popover-portal"}
                                className={"custom-popover"}
                                minimal
                                content={
                                    <div className={"p-2 max-popover-width max-popover-width-prohlizecka"}>
                                        <Linkify text={signRequest.description}/>
                                    </div>
                                }
                                position={Position.BOTTOM_LEFT}
                            >

                                <Linkify className={"truncate-text-prohlizecka"} text={signRequest.description}/>
                            </Popover>
                            {/* {signRequest?.description && <div>Poznámka: {signRequest.description}</div>}*/}
                        </Col>
                    </Row>
                )}
                {(signRequest && mobileInfoVisible && signRequest.attachmentCount > 0) && (
                    <Row className="ml-2 mr-2">
                        <Col className={"meta-items"}>
                            <div className="attachment-section">
                                Dávka obsahuje <span title={`Zobrazit přílohy (${signRequest.attachmentCount})`}
                                                     onClick={() => this.handleZobrazitPrilohy(signRequest.id)}
                                                     className="attachment-link">přílohy</span>
                            </div>
                        </Col>
                    </Row>
                )}
                {mobileInfoVisible && (
                    <Row className="ml-2 mr-2">
                        <Col>{this.renderInfo(inner)}</Col>
                    </Row>
                )}
                {mobileInfoVisible && (
                    <Row className="ml-2 mr-2">
                        <Col className="meta-items">{results}</Col>
                    </Row>
                )}

            </div>
        );
    };
    renderNumberOfPages = (inner) => {
        const {actions, state} = inner;
        const {totalPageCount, actualPage} = state;
        return (
            <div className="number-of-pages">
                {actualPage + 1} / {totalPageCount ? totalPageCount : "?"}
            </div>
        );
    };
    renderFooter = (iconSize, inner) => {
        const stahnoutKosilku = () => {
            const saveData = (function () {
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.setAttribute("style", "display: none");
                return function (blob, fileName) {
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.setAttribute("download", fileName);
                    a.click();
                    window.URL.revokeObjectURL(url);
                };
            }());
            this.setState({generateSummary: true});
            return QSignDataApi.raw.downloadSummary(view.id, documentMeta.id, {responseType: 'blob'}).then((result) => {
                saveData(result.data, "košilka.pdf");
                this.setState({generateSummary: false});
            }).catch(() => {
                this.setState({generateSummary: false});
            });
        }
        const {actions, state} = inner;
        const {totalPageCount} = state;
        const {documentMeta, view} = state;
        const signer = documentMeta && documentMeta.meta && documentMeta.meta.signer;
        const approver = documentMeta && documentMeta.meta && documentMeta.meta.approver;
        const status = documentMeta && documentMeta.meta && documentMeta.meta.status;
        const isForApprove = approver && status === "INIT";
        const isForSign = signer && status === "INIT";
        return (
            <div className={"footer-mobile"}>
                <Row noGutters>
                    <Col xs={4} sm={4} className={"footer-pagination"}>
                        <ButtonGroup>
                            <Button className={"btn-lg"} color={"secondary"} onClick={sinkEvent(actions.prev)}>
                                <Icon icon={"chevron-left"}/>
                            </Button>
                            <Button className={"btn-lg ml-1"} color={"secondary"} onClick={sinkEvent(actions.next)}>
                                <Icon icon={"chevron-right"}/>
                            </Button>
                        </ButtonGroup>
                    </Col>

                    {totalPageCount && (
                        <Col className={"footer-actions"}>

                            <ButtonGroup onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                            }}>
                                <FixedDropDownButton className={"threeDots mobile-dropdown"}
                                                     title={<Icon icon={"ellipsis-v"}/>}>
                                    <DropdownItem className={"three-dots-options py-4"}
                                                  onClick={sinkEvent(actions.firstPage)}><H2
                                        className={"d-flex justify-content-center"}> Přejít na první
                                        stranu </H2></DropdownItem>
                                    <DropdownItem className={"three-dots-options py-4"}
                                                  onClick={sinkEvent(actions.lastPage)}><H2
                                        className={"d-flex justify-content-center"}>Přejít na poslední
                                        stranu</H2></DropdownItem>
                                    <DropdownItem className={"three-dots-options py-4"}
                                                  onClick={sinkEvent(actions.rotateRight)}><H2
                                        className={"d-flex justify-content-center"}>Otočit po směru
                                        hodin</H2></DropdownItem>
                                    <DropdownItem className={"three-dots-options py-4"}
                                                  onClick={sinkEvent(actions.rotateLeft)}><H2
                                        className={"d-flex justify-content-center"}>Otočit proti směru
                                        hodin</H2></DropdownItem>
                                    <DropdownItem className={"three-dots-options py-4"}
                                                  onClick={sinkEvent(actions.download)}><H2
                                        className={"d-flex justify-content-center"}>Stáhnout
                                        dokument</H2></DropdownItem>
                                    <DropdownItem className={"three-dots-options py-4"}
                                                  onClick={sinkEvent(stahnoutKosilku)}><H2
                                        className={"d-flex justify-content-center"}>Vygenerovat a stáhnout
                                        košilku</H2></DropdownItem>
                                </FixedDropDownButton>
                                {isForApprove && (
                                    <FixedDropDownButton className={"decline-mobile mobile-dropdown ml-1"}
                                                         title={<Icon icon={"times"}/>}>

                                        <DropdownItem className={"btn-lg decline decline-options py-4 ml-0"}
                                                      onClick={sinkEvent(() => this.handleNeschvalit(inner))}>
                                            <H2 className={"d-flex justify-content-center"}>Odmítnout</H2>
                                        </DropdownItem>
                                        <DropdownItem className={"btn-lg decline decline-options py-4 ml-0"}
                                                      onClick={sinkEvent(() => this.handleNeschvalitVse(inner))}>
                                            <H2
                                                className={"d-flex justify-content-center"}>Odmítnout vše</H2>
                                        </DropdownItem>
                                    </FixedDropDownButton>
                                )}
                                {isForApprove && (
                                    <FixedDropDownButton title={<Icon icon={"check"}/>}
                                                         className={"approve-mobile mobile-dropdown ml-1"}>

                                        <DropdownItem className={"btn-lg approve approve-options py-4 ml-0"}
                                                      onClick={sinkEvent(() => this.handleSchvalit(inner))}>
                                            <H2 className={"d-flex justify-content-center"}>Schválit</H2>
                                        </DropdownItem>
                                        <DropdownItem className={"btn-lg approve approve-options py-4 ml-0"}
                                                      onClick={sinkEvent(() => this.handleSchvalitVse(inner))}>
                                            <H2
                                                className={"d-flex justify-content-center"}> Schválit vše</H2>
                                        </DropdownItem>
                                    </FixedDropDownButton>
                                )}
                                {!isForApprove && isForSign && (
                                    <FixedDropDownButton className={"decline-mobile mobile-dropdown ml-1"}
                                                         title={<Icon icon={"times"}/>}>

                                        <DropdownItem className={"btn-lg decline decline-options py-4 ml-0"}
                                                      onClick={sinkEvent(() => this.handleOdmitnout(inner))}>
                                            <H2 className={"d-flex justify-content-center"}>Odmítnout</H2>
                                        </DropdownItem>
                                        <DropdownItem className={"btn-lg decline decline-options py-4 ml-0"}
                                                      onClick={sinkEvent(() => this.handleOdmitnoutVse(inner))}>
                                            <H2
                                                className={"d-flex justify-content-center"}> Odmítnout vše</H2>
                                        </DropdownItem>
                                    </FixedDropDownButton>
                                )}
                                {!isForApprove && isForSign && (
                                    <FixedDropDownButton title={<Icon icon={"check"}/>}
                                                         className={"sign-mobile mobile-dropdown ml-1"}>

                                        <DropdownItem className={"btn-lg sign sign-options py-4 ml-0"}
                                                      onClick={sinkEvent(() => this.handlePodepsat(inner))}>
                                            <H2 className={"d-flex justify-content-center"}>Podepsat</H2>
                                        </DropdownItem>
                                        <DropdownItem className={"btn-lg sign sign-options py-4 ml-0"}
                                                      onClick={sinkEvent(() => this.handlePodepsatVse(inner))}>
                                            <H2
                                                className={"d-flex justify-content-center"}> Podepsat vše</H2>
                                        </DropdownItem>
                                    </FixedDropDownButton>
                                )}
                            </ButtonGroup>
                        </Col>
                    )}
                </Row>
            </div>
        );
    };
    renderCloseButton = (iconSize, inner) => {
        const {actions, state} = inner;
        const {closeIcon} = this.props;
        return (
            <div className={"close-button"}>
                <Button className={"btn-transparent"} onClick={actions.close} title={"zavřít"}>
                    <Icon icon={closeIcon + iconSize}/>
                </Button>
            </div>
        );
    };
    renderInfo = (inner) => {
        const {actions, state} = inner;
        const {view, documentIndex, documentMeta} = state;
        const documentName: string =
            view && documentIndex != null ? view.documents[documentIndex].name : "Dokument se Načítá";

        return <>
            <div key="info" className={"pdf-info"}>
                <div className={"pdf-icon"}>{this.renderDocumentIcon()}</div>
                <Label className={"pdf-label"}>{documentName}</Label>
            </div>
            {documentMeta && documentMeta.meta.approving !== "NONE" &&
                <div key="approvering" className="mb-2 mt-3 approvering">
                    {documentMeta.meta.approving === "COMPLETED" &&
                        <span key="completed" className="approvering-completed">Schvalování ukončeno</span>}
                    {documentMeta.meta.approving === "UNDERWAY" &&
                        <span key="underway" className="approvering-underway ">Schvalování probíhá</span>}

                </div>}
        </>;
    };
    renderDocInfo = (inner) => {
        return <div className={"pdf-metadata"}>{this.renderMetadata(inner)}</div>;
    };
    renderDocumentIcon = () => {
        const {documentIcon, documentIconColor} = this.props;
        const iconName = documentIcon ? documentIcon : "file-pdf-o";
        const color = documentIconColor ? documentIconColor : "red";
        return <Icon color={color} icon={iconName}/>;
    };
    changeIndex = (documentIndex, inner) => {
        if (isNaN(documentIndex) || documentIndex === null) {
            return;
        }

        const {actions, state} = inner;
        const {view} = state;

        if (view && view.documents) {
            const documents = view.documents;

            if (documentIndex !== state.documentIndex) {
                if (documentIndex >= 0 && documentIndex < documents.length) {
                    actions.select(view.documents[documentIndex].id);
                }
            }
        }
    };
    renderDocNumLabel = (inner) => {
        const {actions, state} = inner;
        const {view, documentIndex} = state;
        return (
            <Label className={"pdf-doc-num"}>
                Dokument{" "}
                <span onClick={sinkEvent(() => {
                })} className={"current-doc-num"}>
          <DocIndexField
              value={documentIndex + 1}
              min={1}
              max={view.documents.length}
              onChange={(x) => this.changeIndex(x, inner)}
          />
        </span>{" "}
                z {view.documents.length}
            </Label>
        );
    };

    /**
     * Vyrenderuje postranní panel
     * @param iconSize
     * @returns {*}
     */
    renderSidepanel = (iconSize, inner, sent) => {
        const {actions, state} = inner;
        const {view, documentIndex, totalPageCount, documentMeta} = state;
        const disabledSign = !this.state.mouseClick && this.state.stampMode;
        const disabledCursor = sent ? { cursor: "not-allowed"} : {}
        const stahnoutKosilku = () => {
            const saveData = (function () {
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.setAttribute("style", "display: none");
                return function (blob, fileName) {
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.setAttribute("download", fileName);
                    a.click();
                    window.URL.revokeObjectURL(url);
                };
            }());
            this.setState({generateSummary: true});
            return QSignDataApi.raw.downloadSummary(view.id, documentMeta.id, {responseType: 'blob'}).then((result) => {
                saveData(result.data, "košilka.pdf");
                this.setState({generateSummary: false});
            }).catch(() => {
                this.setState({generateSummary: false});
            });
        }
        return (
            <div className="pdf-side-panel flex-column h-100">
                <Row>
                    <Col xs={12} sm={6} lg={9} className={"center-y"}>
                        {view && this.renderDocNumLabel(inner)}
                    </Col>
                    <Col xs={12} sm={4} lg={3}>
                        {this.renderCloseButton(iconSize, inner)}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>{this.renderDocInfo(inner)}</Col>
                </Row>
                {view && (
                    <Row>
                        <Col xs={12}>
                            <div className={"pdf-side-page-control-wrapper"}>
                                <Button disabled={disabledSign} className={"pdf-btn-prev pdf-btn"}
                                        onClick={() => {
                                            actions.prev();
                                            setTimeout(() => {
                                                this.computeSignCoordinates();
                                                this.rerender = true;
                                            }, 100);
                                        }}>
                                    <Icon icon={"chevron-left"}/>
                                    <span className={"pdf-btn-prev-label"}>Předchozí</span>
                                </Button>
                                <Button disabled={disabledSign} className={"pdf-btn-next pdf-btn"}
                                        onClick={() => {
                                            actions.next();
                                            setTimeout(() => {
                                                this.computeSignCoordinates();
                                                this.rerender = true;
                                            }, 100);
                                        }}>
                                    <span className={"pdf-btn-next-label"}>Další</span>
                                    <Icon icon={"chevron-right"}/>
                                </Button>
                            </div>
                        </Col>
                    </Row>
                )}
                <Row>
                    <Col xs={12}>{this.renderInfo(inner)}</Col>
                </Row>
                <Row
                    className="render-actions"
                    style={{
                        minHeight: 0,
                    }}
                >
                    <Col xs={12} className="h-100">
                        {this.renderActions(inner)}
                    </Col>
                </Row>
                {view && (
                    <Row className={"controls-row"}>
                        <Col xs={12} className={"controls-col"}>
                            <div className={"actions-wrapper"} style={{width: "auto"}}>
                                <Button
                                    disabled={totalPageCount == null || sent || disabledSign}
                                    style={disabledCursor}
                                    className={"btn-transparent mr-4"}
                                    title={"Tisknout dokument"}
                                    onClick={() => actions.print(documentIndex)}
                                >
                                    <Icon icon={"print"}/>
                                </Button>
                                <Button
                                    disabled={totalPageCount == null || sent || disabledSign}
                                    style={disabledCursor}
                                    className={"btn-transparent mr-4"}
                                    title={"Stáhnout dokument"}
                                    onClick={actions.download}
                                >
                                    <Icon icon={"download"}/>
                                </Button>
                                <Button
                                    disabled={totalPageCount == null || this.state.generateSummary || disabledSign}
                                    className={"btn-transparent mr-4"}
                                    title={"Vygenerovat a stáhnout košilku"}
                                    /* onClick={() => {
                                         const saveData = (function () {
                                             let a = document.createElement("a");
                                             document.body.appendChild(a);
                                             a.setAttribute("style", "display: none");
                                             return function (blob, fileName) {
                                                 const url = window.URL.createObjectURL(blob);
                                                 a.href = url;
                                                 a.setAttribute("download", fileName);
                                                 a.click();
                                                 window.URL.revokeObjectURL(url);
                                             };
                                         }());
                                         this.setState({generateSummary: true});
                                         return QSignDataApi.raw.downloadSummary(view.id, documentMeta.id, {responseType: 'blob'}).then((result) => {
                                             saveData(result.data, "košilka.pdf");
                                             this.setState({generateSummary: false});
                                         }).catch(() => {
                                             this.setState({generateSummary: false});
                                         });
                                     }}*/
                                    onClick={stahnoutKosilku}
                                >
                                    {this.state.generateSummary ?
                                        <Icon icon="circle-o-notch" animation={Icon.animation.spin}/> :
                                        <Icon icon="paste"/>}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                )}
            </div>
        );
    };

    renderError = (sent) => {
        return (sent &&
            <div className={'document-error'}>
                <div className="warning">Dokument byl odeslán do externího systému</div>
            </div> ||
            <div className={'document-error'}>
                <div>
                    <div className="warning">Dokument se nepodařilo načíst</div>
                    <div className="reason">
                        Možné důvody selhání:
                        <ul>
                            <li>Dokument je poškozen</li>
                            <li>
                                Nemáte dostatečná oprávnění pro zobrazení dokumentu
                            </li>
                            <li>Dokument již není k dispozici</li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Vyrenderuje režim s postraním panelem
     * @returns {*}
     */
    renderBase = (inner) => {
        const iconSize: string = " fa-3x fa-fw";
        const iconSizeSmall: string = " fa-2x fa-fw";
        const {actions, state, pdfWrapper} = inner;
        const {totalPageCount, documentMeta} = state;
        return (
            <div
                className="podepisovani-pdf-viewer base d-flex"
                style={{
                    minHeight: 0,
                }}
            >
                <Container
                    className="pdf-viewer-grid d-flex"
                    style={{
                        flex: 1,
                    }}
                    fluid
                >
                    <div className="main-section h-100">
                        {pdfWrapper(innerHeight * 0.98, null, null, this.renderError(documentMeta && documentMeta.meta.sent))}
                    </div>
                    <div className="side-section">
                        {this.renderSidepanel(iconSize, inner, documentMeta && documentMeta.meta.sent)}
                    </div>
                </Container>
                {totalPageCount != null && this.renderZoomControl(iconSizeSmall, inner)}
            </div>
        );
    };
    calcTouchLine = (e, d) => {
        if (e.touches.length === 2) {
            const moveX = e.touches[0].pageX;
            const moveY = e.touches[0].pageY;
            const moveX2 = e.touches[1].pageX;
            const moveY2 = e.touches[1].pageY;
            const diffX = Math.abs(moveX - moveX2);
            const diffY = Math.abs(moveY - moveY2);
            const exp = Math.pow(diffX, 2) + Math.pow(diffY, 2);
            return Math.sqrt(exp);
        } else {
            return d;
        }
    };
    onTouchStartMobile = (e) => {
        if (e.touches.length === 2) {
            const startLine = this.state.startLine;
            this.setState({
                startLine: this.calcTouchLine(e, startLine),
            });
        }
    };
    onTouchMoveMobile = (e) => {
        if (e.touches.length === 2) {
            const startLine = this.state.startLine;
            this.setState({
                moveLine: this.calcTouchLine(e, startLine),
            });
        }
    };
    onTouchEndMobile = (e, inner) => {
        const {actions, state} = inner;
        const {startLine, moveLine} = this.state;
        const difference = moveLine - startLine;
        const zoom = (moveLine - startLine) / 400;

        if ((difference < 0 && startLine !== 0) || moveLine !== 0) {
            actions.zoomIn(zoom);
        } else if ((difference > 0 && startLine !== 0) || moveLine !== 0) {
            actions.zoomOut(zoom);
        }

        this.setState({
            startLine: 0,
            moveLine: 0,
        }); // reset po nastavení nového zoomu
    };
    renderMobile = (inner) => {
        const iconSize: string = " fa-3x fa-fw";
        const iconSizeSmall: string = " fa-2x fa-fw";
        const {actions, state, pdfWrapper} = inner;
        const {view, totalPageCount, documentMeta} = state;
        const {mobilePanelsVisible} = this.state;
        return (
            <div
                id={"mobile-layout"}
                className="podepisovani-pdf-viewer mobile"
                onScroll={this.handleSetPanelsInvisible}
                onClick={this.handleSetPanelsVisible}
                onTouchStart={this.onTouchStartMobile}
                onTouchMove={this.onTouchMoveMobile}
                onTouchEnd={(e) => this.onTouchEndMobile(e, inner)}
            >
                {pdfWrapper({height: "99.5vh"}, null, null, this.renderError(documentMeta && documentMeta.meta.sent))}
                {view != null && mobilePanelsVisible && this.renderHeader(iconSizeSmall, inner)}
                {mobilePanelsVisible && this.renderFooter(iconSizeSmall, inner)}
                {totalPageCount != null && this.renderNumberOfPages(inner)}
            </div>
        );
    };
    renderLayout = (inner) => {
        const {actions, state} = inner;
        const {viewMode} = this.props;

        this.zoom = inner.state.zoom;

        if (this.rerender) {
            requestAnimationFrame(() => {
                this.computeSignCoordinates();
            });
        }

        switch (viewMode) {
            case PodepisovaniPdfViewer.VIEW_MODE.MOBILE: {
                return this.renderMobile(inner);
            }

            case PodepisovaniPdfViewer.VIEW_MODE.BASE: {
                return this.renderBase(inner);
            }
        }

        return this.renderBase(inner);
    };
    renderPageLayer = (pageNr) => {
        if (this.state.mouseClick) {
            const {
                pageNumber,
                paddingTop,
                paddingLeft,
                marginLeft,
                marginTop,
            } = this.state.mouseClick;
            const {width} = this.props.stampSize;
            const {divWidth} = this.state;

            const divScale = (parseInt(divWidth) / width) - 0.1;

            if (pageNr !== pageNumber) {
                return;
            }

            const scale = this.zoom / this.mouseClickZoom
            if (this.state.mouseClick && !this.state.xScale) {
                requestAnimationFrame(() => {
                    this.computeSignCoordinates();
                });
            }

            const stampColor = this.state.stampMode ? "rgba(0,98,255,0.75)" : "rgba(6,202,84,0.9)";
            const stampBorder = this.state.stampMode ? "blue" : "rgba(0,255,0,0.25)";
            const stampLabel = this.state.stampMode ? "white" : "rgba(0,0,0,0)";
            return (
                <div
                    key="page-layer"
                    style={{
                        position: "absolute",
                        marginLeft: marginLeft,
                        marginTop: marginTop,
                        paddingLeft: paddingLeft,
                        paddingTop: paddingTop,
                        zIndex: 1000
                    }}>

                    <div
                        id={"signDiv"}
                        style={{
                            width: width + "px",
                            backgroundColor: stampColor,
                            position: "relative",
                            left: this.state.xScale + "px",
                            top: this.state.yScale + "px",
                            border: `${stampBorder} 3px solid`,
                            padding: "0.6rem",
                            color: stampLabel,
                            zIndex: 1024,
                            transformOrigin: "left top",
                            transform: "scale(" + scale + ")",
                            overflow: "hidden",
                            resize: !this.state.stampMode ? "none" : "inline",
                            aspectRatio: "5/1"
                        }}
                    >
                        <div
                            style={{
                                width: width + "px",
                                transformOrigin: "left top",
                                transform: "scale(" + divScale + ")",
                                aspectRatio: "46/9"
                            }}
                        >

                            <Row className={"pb-1"}>
                                <Col>
                                    <span className={"color-text-light font-weight-bold"}>Pozice podpisu</span>
                                </Col>
                            </Row>
                            <Row className={"pb-2"}>
                                <Col className={"podepisovani-button pr-0"} xs={"auto"}>
                                    <Button
                                        className={classNames("py-2 d-flex align-items-center", {
                                            "btn-ulozit-umisteni": this.state.stampMode,
                                            "btn-presunout-umisteni": !this.state.stampMode
                                        })}
                                        onClick={() => {
                                            this.setState({
                                                stampMode: !this.state.stampMode,
                                            })
                                        }}
                                    >
                                    <span className={"umisteni-podpisu-text"}>
                                         <Icon className={"pr-2"}
                                               icon={this.state.stampMode ? "floppy-o" : "arrows"}/>{this.state.stampMode ? "Uložit" : "Změnit"} pozici pro všechny dokumenty
                                    </span>
                                    </Button>
                                </Col>
                                <Col className={"podepisovani-button pr-1"} xs={"auto"}>
                                    <Button
                                        className={classNames("py-2 d-flex align-items-center", {
                                            "btn-ulozit-umisteni": this.state.stampMode,
                                            "btn-presunout-umisteni": !this.state.stampMode
                                        })}
                                        style={{zIndex: 1050}}
                                        onClick={(e) => {
                                            this.setState({
                                                mouseClick: null,
                                                xScale: null,
                                                yScale: null,
                                                stampMode: false,
                                                showedPodpis: false
                                            })
                                        }
                                        }
                                    >
                                        <span className={"umisteni-podpisu-text"}><Icon className={"pr-2"}
                                                                                        icon={"times"}/>Zrušit</span>
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    };
    handlePageMouse = (e) => {
        if (this.state.stampMode) {
            this.mouseClickZoom = this.zoom
            this.setState({
                xScale: null,
                yScale: null,
                mouseClick: e,
            });
        }
    };

    render() {
        const {signRequest, screenWidth, ...pdfViewerProps} = this.props;

        /**
         * coNum - Konstantní číslo, které definuje odečet šířky
         * pravého panelu a postraních mezer u načteného dokumentu
         * v PC verzi nad 767px
         */
        const coNum = 0.5;
        const widthToScale = screenWidth / 600;
        const scaleNumber = screenWidth > 767 ? widthToScale * coNum : widthToScale;
        return (
            <PdfViewer
                screenWidth={scaleNumber}
                render={this.renderLayout}
                className="h-100"
                {...pdfViewerProps}
                onPageMouseDown={this.handlePageMouse}
                renderPageLayer={this.renderPageLayer}
                onZoomChanged={this.computeSignCoordinates}
            />
        );
    }
}

export default withRouter(connect()(PodepisovaniPdfViewer));
